import { msg } from "@lingui/core/macro";
import { Member } from "../../constants";

const {
  INVALID_MEMBER_KEY,
  MEMBER_ALREADY_REGISTERED, // General already registered error that could refer to the MCID
  EMAIL_ALREADY_REGISTERED, // Specific to email check
  MISSING_REQUEST_BODY_FIELD,
  FAIL_ON_UNKNOWN_PROPERTIES,
  FAIL_ON_PROGRAM_LOOKUP,
  AUTHENTICATION_INVALID_CREDENTIALS,
  AUTHENTICATION_FAILURE_USER_NOT_FOUND,
  AUTHENTICATION_FAILURE_EXTERNAL_SYSTEM_ERROR,
  SHARED_SECRET_INVALID,
  AUTHENTICATION_FAILURE_MEMBERSHIP_NOT_ACTIVE,
  AUTHENTICATION_FAILURE_MEMBERSHIP_CLOSED,
  AUTHENTICATION_FAILURE_MEMBERSHIP_SUSPENDED,
  TOO_MANY_REQUESTS,
  INVALID_CAPTCHA,
} = Member;

export const signUpSteps = {
  GENERAL: "GENERAL",
  EMAIL: "EMAIL",
  NAME: "NAME",
  PASSWORD: "PASSWORD",
  REGISTRATION_CODE: "REGISTRATION_CODE",
  MEMBER_ID: "MEMBER_ID",
};

export const errorLocations = {
  SIGN_IN_EMAIL: "SignIn-email",
  SIGN_IN_PASSWORD: "SignIn-password",
  SIGN_UP_MEMBERID: "SignUp-memberID",
  SIGN_UP_EMAIL: "SignUp-email",
  SIGN_UP_REGISTRATION_CODE: "SignUp-registrationCode",
  GENERAL: "general",
};
export const getAuthError = (
  code,
  helpNumber,
  mcidRegistration = false,
  completeProfile = false,
) => {
  const cvtCompleteError =
    completeProfile && !mcidRegistration && code !== MEMBER_ALREADY_REGISTERED;
  if (cvtCompleteError) {
    code = MISSING_REQUEST_BODY_FIELD;
  }

  const problemRegMsg = msg`Please try registering with a different email address or contact your association for further assistance. If you continue to experience issues with your registration, please call Member Services at <span>${helpNumber}</span>.`;
  const problemAuthMsg = msg`Sorry, there was a problem with your account. Please call Member Services at <span>${helpNumber}</span>.`;
  const programAuthMismatchMsg = msg`The email address and password you have entered do not match our records.`;
  const errObjArray = [
    {
      errorCode: FAIL_ON_PROGRAM_LOOKUP,
      errorMsg: msg`There was an error loading your program's information. Please reload the page to try again.`,
      location: errorLocations.GENERAL,
    },
    {
      errorCode: AUTHENTICATION_FAILURE_USER_NOT_FOUND, // from registration
      errorMsg: problemRegMsg,
      location: errorLocations.GENERAL,
    },
    {
      errorCode: AUTHENTICATION_INVALID_CREDENTIALS, // from sign in
      errorMsg: programAuthMismatchMsg,
      location: errorLocations.GENERAL,
    },
    {
      errorCode: AUTHENTICATION_FAILURE_EXTERNAL_SYSTEM_ERROR,
      errorMsg: msg`Oops! We had a problem and notified a developer. Please try again.`,
      location: errorLocations.GENERAL,
    },
    {
      errorCode: INVALID_MEMBER_KEY,
      errorMsg: msg`Please try with a different MCID. If problem persists, please contact your program for help.`,
      location: errorLocations.SIGN_UP_MEMBERID,
    },
    {
      errorCode: EMAIL_ALREADY_REGISTERED,
      errorMsg: msg`This email address has already been registered.`,
      location: errorLocations.SIGN_UP_EMAIL,
    },
    {
      errorCode: MEMBER_ALREADY_REGISTERED,
      errorMsg: !mcidRegistration
        ? msg`This email address has already been registered.`
        : msg`*Member ID has already been registered. Please sign in.`,
      location: !mcidRegistration ? errorLocations.SIGN_UP_EMAIL : errorLocations.SIGN_UP_MEMBERID,
    },
    {
      errorCode: SHARED_SECRET_INVALID,
      errorMsg: msg`Please try with a different Registration Code. If problem persists, please contact your program for help.`,
      location: errorLocations.SIGN_UP_REGISTRATION_CODE,
    },
    {
      errorCode: FAIL_ON_UNKNOWN_PROPERTIES,
      errorMsg: msg`*Email not found, contact your admin to be added`,
      location: errorLocations.SIGN_UP_EMAIL,
    },
    {
      errorCode: INVALID_CAPTCHA,
      errorMsg: msg`Whoops, something went wrong. Please try again. If the problem persists, call Member Services at <span>${helpNumber}</span>.`,
      location: errorLocations.GENERAL,
    },
    {
      errorCode: TOO_MANY_REQUESTS,
      errorMsg: msg`You've reached the maximum number of attempts. Please try again later.`,
      location: errorLocations.GENERAL,
    },
    {
      errorCode: AUTHENTICATION_FAILURE_MEMBERSHIP_NOT_ACTIVE,
      errorMsg: problemAuthMsg,
      location: errorLocations.GENERAL,
    },
    {
      errorCode: AUTHENTICATION_FAILURE_MEMBERSHIP_CLOSED,
      errorMsg: problemAuthMsg,
      location: errorLocations.GENERAL,
    },
    {
      errorCode: AUTHENTICATION_FAILURE_MEMBERSHIP_SUSPENDED,
      errorMsg: problemAuthMsg,
      location: errorLocations.GENERAL,
    },
  ];

  const userErrorObj = errObjArray.find((errorObj) => errorObj.errorCode === code);

  const defaultErrorObj = {
    errorMsg: problemRegMsg,
    location: errorLocations.GENERAL,
  };

  return userErrorObj || defaultErrorObj;
};

/**
 * @description
 * - fires off a heap tracking event if heap exists on the window
 * - heap gets added by the <AddOns /> component via the ARC <Analytics /> component
 * @param msg: {string} an event message to send to heap
 * @return no return needed;
 */
export const fireHeapTrackingEvent = (msg) => {
  if (window["heap"]) {
    window["heap"].track(msg);
  }
};
